module.exports = __webpack_public_path__ + "static/media/card.0de72c6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/TransactionsTable/images/card.svg
// module id = 651
// module chunks = 0